import { render, staticRenderFns } from "./ProductPhoto.vue?vue&type=template&id=58d192d4&"
import script from "./ProductPhoto.vue?vue&type=script&lang=js&"
export * from "./ProductPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports